<template>
  <v-card>
    <v-card-text>
      <apexchart
        :options="chartOptions"
        :series="seriesSanitizadas"
        type="bar"
        height="400"
        width="100%"
      ></apexchart>

      <h3 class="text-center mb-3">Diferencia:</h3>
      <v-row justify-center>
        <v-col
          v-for="(item, idx) in datosDiferenciaSanitizada"
          :key="'dif-' + idx"
          cols="3"
          md="3"
        >
          <div class="text-center">
            <span
              class="text-subtitle-2"
              :style="item >= 0 ? 'color: green' : 'color: red'"
            >
              {{ formatoPrecio(item) }}
            </span>
          </div>
        </v-col>
      </v-row>

      <v-row justify-center>
        <v-col
          v-for="(item, idx) in trimestres"
          :key="'trim-' + idx"
          cols="3"
          md="3"
        >
          <div class="text-center">{{ item }}</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    chartSeries: {
      type: Array,
      required: true,
    },
    datosDiferencia: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // Forzamos que las series sean siempre números válidos
    seriesSanitizadas() {
      return this.chartSeries.map((serie) => ({
        ...serie,
        data: (serie.data || []).map((v) => {
          const num = parseFloat(v);
          return isNaN(num) ? 0 : num;
        }),
      }));
    },
    // Sanitizar datos de diferencia también
    datosDiferenciaSanitizada() {
      return this.datosDiferencia.map((v) => {
        const num = parseFloat(v);
        return isNaN(num) ? 0 : num;
      });
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      chartOptions: {
        title: {
          text: "Ventas por trimestre",
          align: "Center",
          margin: 8,
          style: {
            fontSize: "20px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        chart: {
          type: "bar",
          stacked: false,
          locales: [
            {
              name: "es",
              options: {
                months: [
                  "Enero",
                  "Febrero",
                  "Marzo",
                  "Abril",
                  "Mayo",
                  "Junio",
                  "Julio",
                  "Agosto",
                  "Septiembre",
                  "Octubre",
                  "Noviembre",
                  "Diciembre",
                ],
                shortMonths: [
                  "Ene",
                  "Feb",
                  "Mar",
                  "Abr",
                  "May",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dic",
                ],
                days: [
                  "Domingo",
                  "Lunes",
                  "Martes",
                  "Miércoles",
                  "Jueves",
                  "Viernes",
                  "Sábado",
                ],
                shortDays: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
              },
            },
          ],
          defaultLocale: "es",
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#333"],
            fontSize: "14px",
          },
          background: {
            enabled: true,
            foreColor: "#fff",
            borderRadius: 2,
            padding: 8,
            opacity: 0.7,
            borderWidth: 1,
            borderColor: "#fff",
          },
          formatter: function (value) {
            const num = parseFloat(value);
            if (isNaN(num)) return "0";
            // Usar coma como separador de miles (estilo es-MX)
            return (
              "$" +
              num.toLocaleString("es-MX", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })
            );
          },
        },
        colors: ["#FF1654", "#247BA0"],
        stroke: {
          width: [2, 2],
        },
        plotOptions: {
          bar: {
            columnWidth: "60%",
            borderRadius: 3,
            borderRadiusApplication: "end",
          },
        },
        xaxis: {
          categories: [
            "1er trimestre",
            "2do trimestre",
            "3er trimestre",
            "4to trimestre",
          ],
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              const num = parseFloat(value);
              if (isNaN(num)) return "0";
              const partes = num.toFixed(2).split(".");
              partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              return "$" + partes.join(".");
            },
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        legend: {
          horizontalAlign: "center",
        },
        // <-- AQUÍ FORZAMOS EL CAMBIO EN MÓVILES
        /*responsive: [
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  horizontal: true,
                  barHeight: "60%", // Ajusta la altura de las barras
                },
              },
              dataLabels: {
                style: { fontSize: "10px" }, // Texto más chico en móvil
              },
              chart: {
                height: 500, // Ajusta para que no se corte
              },
            },
          },
        ],*/
      },
      trimestres: [
        "1er trimestre",
        "2do trimestre",
        "3er trimestre",
        "4to trimestre",
      ],
    };
  },
  methods: {
    formatoPrecio(precio) {
      const num = parseFloat(precio);
      if (isNaN(num)) return "0";
      return num.toLocaleString("es-MX", {
        minumumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },
  components: { apexchart: VueApexCharts },
};
</script>
